/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react"
import { useRouteMatch } from "react-router"
import Grid from "../../../components/Grid/Grid"
import { iArtPiece, iArtPieceQuery } from "../../../definitions/ArtPieces"
import { useData } from "../../../hooks/useData"
import ArtPieceFilters from "../../ArtPieces/Filters"
import ArtPieceItem from "../../ArtPieces/Item"
import SelectItem from "../../../components/Grid/SelectItem"
import Loader from "../../../components/Loader/Loader"
import { iUrlParams } from "../../../definitions/interfaces"
import Pagination from "../../../components/Pagination/Pagination"
import { useSelector } from "../../../store"
import { store } from "react-notifications-component"
import { notificationOptions } from "../../../api/Definitions"
interface iProps {
  onChange?: (...event: any[]) => void
  value?: any
}

const ManageArtPieces: FunctionComponent<iProps> = ({ onChange }) => {
  const user = useSelector(({ user }) => user)

  const artPiecesPerExhibition = useMemo(() => {
    console.log(user)

    const { package: userPackage } = user || {}
    const { artPiecesPerExhibition = 0 } = userPackage || {}
    if (user.roles && user.roles.includes("admin")) {
      return -1
    }
    return artPiecesPerExhibition
  }, [user])

  const match = useRouteMatch<iUrlParams>()

  const { data } = useData<iArtPieceQuery, iArtPiece>({
    link: "/v2/exhibitions/" + match.params.url + "/art-pieces",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const [selectedArtPieces, setSelectedArtPieces] = useState<iArtPiece[]>(data)
  const _selected = useRef<iArtPiece[]>(data)

  useEffect(() => {
    setSelectedArtPieces(data)
    _selected.current = data
  }, [data])

  const { data: artPieces, total, query, setQuery, loading } = useData<
    iArtPieceQuery,
    iArtPiece
  >({
    link: "/v1/art-pieces",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const handleClickOnArtPiece = useCallback(
    (art: iArtPiece) => {
      if (_selected.current.find((a) => a._id === art._id)) {
        _selected.current = _selected.current.filter((a) => a._id !== art._id)
      } else {
        if (
          artPiecesPerExhibition !== -1 &&
          artPiecesPerExhibition <= _selected.current.length
        ) {
          store.addNotification({
            title: "Limit",
            message: `You can use ${artPiecesPerExhibition} art pieces per exhibition`,
            type: "warning",
            ...notificationOptions,
          })
          return
        }
        _selected.current = [..._selected.current, art]
      }
      setSelectedArtPieces(_selected.current)
      onChange &&
        onChange(_selected.current.map((ap) => ({ artPieceId: ap._id })))
    },
    [selectedArtPieces],
  )

  const removeArtPiece = useCallback(
    (art: iArtPiece) => {
      const tmp = _selected.current.filter((ap) => ap._id !== art._id)
      _selected.current = tmp
      setSelectedArtPieces(tmp)
      onChange && onChange(tmp.map((ap) => ({ artPieceId: ap._id })))
    },
    [selectedArtPieces],
  )

  return (
    <>
      <div className="content-header">
        <ArtPieceFilters query={query} setQuery={setQuery} />
      </div>
      <div className="flex-grids">
        <div className="col-6 grid-wrap">
          <label>Select art</label>
          {loading ? (
            <Loader />
          ) : (
            <Grid>
              {artPieces.map((art) => (
                <SelectItem<iArtPiece>
                  key={art._id}
                  item={art}
                  isSelected={
                    selectedArtPieces.find(({ _id }) => _id === art._id)
                      ? true
                      : false
                  }
                  onClick={handleClickOnArtPiece}
                >
                  <ArtPieceItem showViewButton {...art} />
                </SelectItem>
              ))}
            </Grid>
          )}
        </div>
        <div className="grid-separator"> </div>
        <div className="col-6 grid-wrap selected-wrap">
          <label>Art selected</label>
          <Grid>
            {selectedArtPieces.map((art) => (
              <SelectItem<iArtPiece>
                key={art._id}
                item={art}
                isSelected={false}
                onClick={removeArtPiece}
              >
                <ArtPieceItem showViewButton {...art} />
              </SelectItem>
            ))}
          </Grid>
        </div>
      </div>
      <Pagination total={total} setQuery={setQuery} limit={50} />
    </>
  )
}

export default ManageArtPieces
